import { ScoreEntry } from '@/types/cricket';
import { 
  ScoreComponents, 
  getScoreComponents, 
  isBoundaryBall, 
  isExtraBall as isExtraBallType 
} from './types';
import { supabase } from '@/integrations/supabase/client';
import { Team } from '@/types/cricket';

export const calculateTotalRuns = (ball: ScoreEntry): number => {
  const components = getScoreComponents(ball);
  return components.total;
};

export const isBoundary = (ball: ScoreEntry): boolean => {
  return isBoundaryBall(ball);
};

export const isExtraBall = (ball: ScoreEntry): boolean => {
  return isExtraBallType(ball);
};

export const getExtraTypeDisplay = (extraType: string): string => {
  switch (extraType) {
    case 'wide': return 'Wd';
    case 'noball': return 'Nb';
    case 'bye': return 'B';
    case 'legbye': return 'Lb';
    default: return extraType;
  }
};

export const calculateRunRate = (runs: number, overs: number, balls: number): number => {
  const totalBalls = overs * 6 + balls;
  if (totalBalls === 0) return 0;
  return Number(((runs / totalBalls) * 6).toFixed(2));
};

export const calculateExtrasFromScoreHistory = async (matchId: string, inningsNumber: number): Promise<number> => {
  const { data } = await supabase
    .from('score_history')
    .select('extras')
    .eq('match_id', matchId)
    .eq('innings', inningsNumber);
  
  return data?.reduce((sum, entry) => sum + (entry.extras || 0), 0) || 0;
};

export const getTeamCaptain = (teamId: string, teams: Team[]): string | undefined => {
  const team = teams.find(t => t.id === teamId);
  return team?.players?.find(p => p.isCaptain)?.id;
}; 